// Get My Creators Groups
export const GET_MY_CREATORS_GROUPS_REQUEST = 'GET_MY_CREATORS_GROUPS_REQUEST';
export const GET_MY_CREATORS_GROUPS_DONE = 'GET_MY_CREATORS_GROUPS_DONE';
export const GET_MY_CREATORS_GROUPS_FAILED = 'GET_MY_CREATORS_GROUPS_FAILED';
export const GET_MY_CREATORS_GROUPS_RESET = 'GET_MY_CREATORS_GROUPS_RESET';

// Poll My Creators Groups (background, no loading state reset)
export const POLL_MY_CREATORS_GROUPS_REQUEST = 'POLL_MY_CREATORS_GROUPS_REQUEST';
export const POLL_MY_CREATORS_GROUPS_DONE = 'POLL_MY_CREATORS_GROUPS_DONE';

// Operations
export const TOGGLE_MY_CREATORS_GROUPS = 'TOGGLE_MY_CREATORS_GROUPS';
export const TOGGLE_ALL_MY_CREATORS_GROUPS = 'TOGGLE_ALL_MY_CREATORS_GROUPS';
export const MY_CREATORS_GROUPS_SET_PAGE = 'MY_CREATORS_GROUPS_SET_PAGE';